import { Field } from '../field/field.model';
import * as actions from './job.actions';
import { Job } from './job.model';
import { State } from './job.reducer';
import { handleFields, handleFieldValue, shouldUpdate } from './job.reducer.helpers';

export const updateFromApiReducer = (
    action: actions.UpdateFromApi,
    state: State
): State => {

    return action.payload.jobs
        .reduce((s, remote) => {

            const local = s.entities[remote.id];

            // the remote job does not exist locally
            if (!local) {
                s.ids = [...s.ids, remote.id];
                s.entities[remote.id] = new Job({
                    ...remote,
                    fields: remote.fields.map(handleFieldValue)
                });
                return s;
            }

            const oldFields = local ? local.fields : [];
            const oldFieldMap: Map<string, Field> = new Map();
            oldFields.forEach(f => oldFieldMap.set(f.id, f));
            let jobToInsert: Job;
            // decide which fields we are going to insert into the state
            const fields = handleFields(remote.fields, oldFieldMap);

            // decide if we are going to update the state with the remote
            // job or keep the local one
            if (!shouldUpdate(remote, local)) {
                jobToInsert = local;
            } else {
                // update the job to insert with the fields and calculate
                // the dirty flag
                jobToInsert = new Job({
                    ...remote,
                    fields,
                    dirty: false
                });
            }

            s.entities[jobToInsert.id] = jobToInsert;
            return s;
        }, {
            ...state,
            // we need to clone the objects to avoid Object.lock errors
            ids: [...state.ids],
            entities: {...state.entities}
        });
};



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job.update-from-api.reducer.ts